export default __webpack_public_path__ + "static/media/mysql-logo.3737d1ef.svg";